import ContentLoader from 'react-content-loader';

import { DEFAULT_SETTINGS } from '@web/components/skeletonLoaders/constants';

const SEARCH_ITEM_CONTENT_HEIGHT = 40;

export const SearchContentSkeleton = () => {
  const viewBox = `0 0 450 ${SEARCH_ITEM_CONTENT_HEIGHT}`;

  return (
    <ContentLoader height={SEARCH_ITEM_CONTENT_HEIGHT} viewBox={viewBox} {...DEFAULT_SETTINGS}>
      <rect x="0" y="0" rx="0" ry="0" width="450" height={SEARCH_ITEM_CONTENT_HEIGHT} />
    </ContentLoader>
  );
};
